import ApiClient from './ApiClient';

export default class TariffsApi extends ApiClient {
  /**
   * Загрузить список тарифов
   * @param regionId
   * @returns {*}
   */
  fetchTariffs (regionId) {
    return this.get(`${this.prefix}tariff/info`, { regionId });
  }

}



// WEBPACK FOOTER //
// ./src/api/Tariffs.js